(function () {
  // Centralized init for image/video lazy-load controllers.
  function initHollyVisibility(root) {
    if (window.HollyImageVisibility) {
      window.HollyImageVisibility.init(root);
    }
    if (window.HollyVideoVisibility) {
      window.HollyVideoVisibility.init(root);
    }
  }

  function setupHollyVisibility() {
    // Initial full-page scan once scripts are ready.
    initHollyVisibility(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHollyVisibility);
  } else {
    setupHollyVisibility();
  }

  document.addEventListener('shopify:section:load', function (event) {
    // Re-scan only the loaded section in theme editor or dynamic inserts.
    initHollyVisibility(event.target);
  });
})();
